import React from "react";
import { MonthColumn } from "../../../../types/IFavoriteOrigins";

interface OriginManagerBottomScrollbarProps {
  monthColumns: Array<MonthColumn & { colSpan?: number }>;
  monthGridTemplateColumns: string;
  bottomMonthScrollbarRef: React.RefObject<HTMLDivElement>;
  onScroll: (event: React.UIEvent<HTMLDivElement>) => void;
}

const OriginManagerBottomScrollbar: React.FC<OriginManagerBottomScrollbarProps> = ({
  monthColumns,
  monthGridTemplateColumns,
  bottomMonthScrollbarRef,
  onScroll,
}) => {
  return (
    <div className="dom-pane-row dom-month-scrollbar-wrap" aria-hidden="true">
      <div className="dom-pane-left dom-month-scrollbar-left-spacer" />
      <div
        ref={bottomMonthScrollbarRef}
        className="dom-month-scrollbar"
        onScroll={onScroll}
      >
        <div
          className="dom-pane-month-grid dom-month-scrollbar-track"
          style={{ gridTemplateColumns: monthGridTemplateColumns }}
        >
          {monthColumns.map((column) => (
            <div
              key={`scrollbar-${column.month}-${column.half}`}
              className="dom-month-scrollbar-cell"
            />
          ))}
        </div>
      </div>
      <div className="dom-pane-right dom-month-scrollbar-right-spacer" />
    </div>
  );
};

export default OriginManagerBottomScrollbar;
